import { FunctionComponent, memo, RefObject } from "react";
import { createPortal } from "react-dom";

import { classNames } from "@/utils/classNames";
import { useAppSelector } from "@/redux/hooks";
import { listSelector } from "@/pages/Private/redux/list/list.slice";

import { useAddInboxChat } from "../../../List/components/CampaignOverview/utils/useAddInboxChat";

interface OutboxChatTabProps {
	selected: number[];
	isLoadingGetUnassigned: boolean;
	sendButtonsPortalRef: RefObject<HTMLDivElement | null>;
}

export const OutboxChatTab: FunctionComponent<OutboxChatTabProps> = memo(
	({ selected, isLoadingGetUnassigned, sendButtonsPortalRef }) => {
		const { inbox, currentLeadIndex } = useAppSelector(listSelector);
		const { renderChatlog, renderSendButtons } = useAddInboxChat({
			prefillDrafts: true,
		});

		return (
			<>
				<div
					className={classNames(
						"h-full min-h-[100%] w-full z-5 relative",
						selected.length > 0 ? "blur" : ""
					)}
				>
					{inbox?.length > 0 &&
						!!inbox[currentLeadIndex] &&
						renderChatlog(selected, isLoadingGetUnassigned)}
				</div>

				{sendButtonsPortalRef.current &&
					createPortal(renderSendButtons(), sendButtonsPortalRef.current)}
			</>
		);
	}
);

OutboxChatTab.displayName = "OutboxChatTab";
